<template>
  <div class="dashboard page-content__header-description">
    <h1 style="flex: 1" class="page-title">Performance</h1>
    <!-- class="widget widget-alpha widget-alpha--color-amaranth" -->
    <div
      v-if="showOffOnlinelineDevices != null"
      style="flex-flow: row; display: flex; flex: 1; margin-bottom: 8px"
    >
      <span
        style="float: right; display: block; display: flex"
        class="label-container"
      >
        <!-- {{value}} -->
        <!-- {{showOffOnlinelineDevices}} -->
        <!-- :type="" -->
        <div>
          <span
            class="default-label"
            :class="{
              'active-blue-filter':
                showOffOnlinelineDevices === 3 && !showCritical
            }"
            @click="toggleShowOfflineOnlineDevices('All')"
          >
            <p class="blue-label">All</p>
            <p class="device-amount">{{ filteredAllDevices.length }}</p>
          </span>
        </div>
        <div>
          <span
            class="default-label"
            :class="{
              'active-green-filter':
                showOffOnlinelineDevices === 1 && !showCritical
            }"
            @click="toggleShowOfflineOnlineDevices('Online')"
          >
            <p class="green-label">Online</p>
            <p class="device-amount">{{ filteredOnlineDevices.length }}</p>
          </span>
        </div>
        <div>
          <span
            class="default-label"
            :class="{
              'active-yellow-filter':
                showOffOnlinelineDevices === 2 && !showCritical
            }"
            @click="toggleShowOfflineOnlineDevices('Offline')"
          >
            <p class="yellow-label">Offline</p>
            <p class="device-amount">{{ filteredOffLineDevices.length }}</p>
          </span>
        </div>
        <div>
          <span
            class="default-label"
            :class="{
              'active-red-filter':
                showOffOnlinelineDevices === 4 && !showCritical
            }"
            @click="toggleShowOfflineOnlineDevices('Alarm')"
          >
            <p class="red-label">Alarms</p>
            <p class="device-amount">{{ filteredAlarmDevices.length }}</p>
          </span>
        </div>
        <div>
          <span
            class="default-label"
            :class="{ 'active-orange-filter': showCritical }"
            @click="toggleShowOfflineOnlineDevices('critical')"
          >
            <p class="orange-label">Inverter Not Detected</p>
            <p class="device-amount">{{ criticalSystems.length }}</p>
          </span>
        </div>
      </span>
      <!--
        <vk-iconnav>
        <vk-iconnav-item
          class="critical_pin"
          style="color: red !important"
          href="#"
          @click="toggleShowOfflineOnlineDevices('critical')"
          icon="warning"
        ></vk-iconnav-item>
        <vk-iconnav-item
          href="#"
          @click="searchToggle"
          icon="search"
        ></vk-iconnav-item>
        <i
          class="el-icon-s-operation"
          @click="toggleFilters"
          style="font-size: 16pt"
        ></i>
        <vk-iconnav-item href="#" icon="copy"></vk-iconnav-item>
        <vk-iconnav-item href="#" icon ="trash"></vk-iconnav-item>
      </vk-iconnav> -->
    </div>
    <!-- widget widget-alpha widget-alpha--color-amaranth -->
    <div class style="display: flex; flex-flow: row">
      <div
        class="table-header-custom"
        style="margin-bottom: 12px; margin-right: 5pt"
        v-show="showFilters"
      >
        <el-dropdown>
          <el-button size="small" round class="el-dropdown-link">
            {{
              this.filterFirmWarVersion ? this.filterFirmWarVersion : "Version"
            }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :key="fv.id" v-for="fv in uniqueFV">
              <span @click="handleVersionFilterEnabler(fv.FV)">
                {{ fv.FV }}
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
          <!-- <i>{{this.filterFirmWarVersion}}</i> -->
        </el-dropdown>
      </div>
      <div
        class="table-header-custom border"
        style="margin-bottom: 12px; margin-right: 5pt"
        v-show="showFilters"
      >
        <el-dropdown>
          <el-button size="small" round class="el-dropdown-link">
            {{ this.filterSectorVal ? this.filterSectorVal : "Sector" }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :key="item.id" v-for="item in uniqueSectors">
              <span @click="handleSectorFilterEnabler(item.sector)">
                {{ item.sector }}
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
          <!-- <i>{{this.filterSectorVal}}</i> -->
        </el-dropdown>
      </div>
      <div
        class="table-header-custom border"
        style="margin-bottom: 12px; margin-right: 5pt"
        v-show="showFilters"
      >
        <el-dropdown>
          <el-button size="small" round class="el-dropdown-link">
            {{
              this.filterPaymentModel
                ? this.filterPaymentModel
                : "Payment Model"
            }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :key="item.id" v-for="item in uniquePaymentModel">
              <span
                @click="handlePaymentModelFilterEnabler(item.paymentModel)"
                >{{ item.paymentModel }}</span
              >
            </el-dropdown-item>
          </el-dropdown-menu>
          <!-- <i>{{this.filterSectorVal}}</i> -->
        </el-dropdown>
      </div>
    </div>
    <div class="display-search-bar">
      <h3 v-show="paginatedInfo.ofText">
        Showing
        {{
          paginatedInfo.total > 0
            ? `${paginatedInfo.first} - ${paginatedInfo.last}
        ${paginatedInfo.ofText} ${paginatedInfo.total} ${
                paginatedInfo.total > 1 ? "Devices" : "Device"
              }`
            : "no device"
        }}
      </h3>
      <div class="t" v-show="showSearch && !showCritical">
        <el-input
          style="width: 50%"
          placeholder="Search All Devices"
          prefix-icon="el-icon-search"
          v-model="searchTerm"
        ></el-input>
      </div>
    </div>

    <div class="main-container">
      <!-- {{showOffOnlinelineDevices===2 && !showCritical +': Offline'}}
      {{showOffOnlinelineDevices===3 && !showCritical +': All'}}
      {{showOffOnlinelineDevices===1 && !showCritical +': Online'}}-->
      <div v-if="showOffOnlinelineDevices === 2 && !showCritical">
        <OfflineDevices
          v-show="showOffOnlinelineDevices === 2 && !showCritical"
          :showCritical="showCritical"
          :activeTab="showOffOnlinelineDevices === 2 && !showCritical"
          :showOfflineDevices="showOffOnlinelineDevices"
          :tableRowClicked="tableRowClicked"
          :fields_="fields_"
          :items="items"
          :searchTerm="searchTerm"
          :filteredOffLineDevices="filteredOffLineDevices"
          @paginated-info="paginatedInfo = $event"
          :formatDate="formatDate"
        />
      </div>
      <div v-if="showOffOnlinelineDevices === 4 && !showCritical">
        <AlarmDevices
          v-show="showOffOnlinelineDevices === 4 && !showCritical"
          :showCritical="showCritical"
          :activeTab="showOffOnlinelineDevices === 4 && !showCritical"
          :showAlarmDevices="showOffOnlinelineDevices"
          :tableRowClicked="tableRowClicked"
          :fields_="fields_"
          :items="items"
          :searchTerm="searchTerm"
          :filteredAlarmDevices="filteredAlarmDevices"
          @paginated-info="paginatedInfo = $event"
          :formatDate="formatDate"
        />
      </div>
      <div v-if="showOffOnlinelineDevices === 1 && !showCritical">
        <OnLineDevices
          :v-show="showOffOnlinelineDevices === 1 && !showCritical"
          :showOnlineDevices="showOffOnlinelineDevices"
          :activeTab="showOffOnlinelineDevices === 1 && !showCritical"
          :showCritical="showCritical"
          :tableRowClicked="tableRowClicked"
          :fields_="fields_"
          :items="items"
          :searchTerm="searchTerm"
          :filteredOnlineDevices="filteredOnlineDevices"
          @paginated-info="paginatedInfo = $event"
          :formatDate="formatDate"
        />
      </div>
      <div v-if="showOffOnlinelineDevices === 3 && !showCritical">
        <AllDevices
          :v-show="showOffOnlinelineDevices === 3 && !showCritical"
          :showAllDevices="showOffOnlinelineDevices"
          :activeTab="showOffOnlinelineDevices === 3 && !showCritical"
          :showCritical="showCritical"
          :tableRowClicked="tableRowClicked"
          :fields_="fields_"
          :items="items"
          :searchTerm="searchTerm"
          :filteredAllDevices="filteredAllDevices"
          @paginated-info="paginatedInfo = $event"
          :formatDate="formatDate"
        />
      </div>
     
      <div v-if="showOffOnlinelineDevices === null && !showCritical && !loadingState">
        no data
      </div>
      <div class="loadingState" v-if="loadingState">
        Loading, please wait.....
      </div>
      <div style="width: 100%" v-if="showCritical">
        <h2>Inverter not detected</h2>
        <!-- {{criticalSystems}} -->
        <vue-good-table
          class="table"
          :columns="criticalColumns"
          :rows="criticalSystems"
          :line-numbers="true"
        >
          <!-- <template slot="table-row" slot-scope="props" style="background: red;">
            <span v-if="props.column.field == 'status'">
              <div
                class="table_status"
                :class="{
                  'badge-danger': statusCalc(props.row.TimeStamp),
                  'badge-success': !statusCalc(props.row.TimeStamp)
                }"
              ></div>
            </span>
            <span v-else-if="props.column.field == 'ownerName'">{{ props.row.ownerName }}</span>
            <span v-else-if="props.column.field == 'deviceType'">{{ props.row.deviceType }}</span>
            <span v-else-if="props.column.field == 'deviceType'">{{ props.row.deviceType }}</span>
            <span v-else-if="props.column.field == 'version'">{{ props.row.version }}</span>
            <span v-else-if="props.column.field == 'panelpower'">{{ props.row.panelpower }}</span>
            <span v-else-if="props.column.field == 'InverterId'">{{ props.row.InverterId }}</span>
            <span v-else-if="props.column.field == 'lastseen'">{{ timeAgo(props.row.Timestamp) }}</span>
            <span
              v-else-if="props.column.field == 'batterystatus'"
              style="display: flex; flex-flow: row;"
            >
              <battery
                :mini="true"
                :width="`18px`"
                :height="`10px`"
                :direction="`y`"
                style="margin-top: 5px;"
                :level="props.row.BatteryCapacity"
              ></battery>

              <span>{{ `${props.row.BatteryCapacity * 1}%` }}</span>
            </span>

            <span v-else>{{ props.row[props.column.field] }}</span>
          </template>

          <template slot="pagination-bottom" slot-scope="props">
            <grey-pagination
              :total="props.total"
              :pageChanged="props.pageChanged"
              :perPageChanged="props.perPageChanged"
            ></grey-pagination>
          </template>-->
        </vue-good-table>
      </div>
    </div>

    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
  <!-- </div> -->
</template>

<script>
/* eslint-disable */
// import Widget from "../../vuestic-components/vuestic-widget/VuesticWidget";
// import Modal from "../../vuestic-components/vuestic-modal/VuesticModal";
// import InstallationStat from "./installationStat";
// import VuesticSimpleSelect from "../../vuestic-components/vuestic-simple-select/VuesticSimpleSelect";

import Vue from "vue";
import Simplert from "vue2-simplert";
import powerStat from "./powerStat";
import { timeAgoUtil } from "../../../main";
import moment from "moment";
import payloadDictionary from "./payload_dictionary.json";
import dummyData from "./dummy.json";
import Battery from "../kitchen/grey-battery";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import OfflineDevices from "./widgets/offlineDevices";
import AlarmDevices from "./widgets/alarmDevices";
import OnLineDevices from "./widgets/onLineDevices";
import AllDevices from "./widgets/allDevices";
import { Icon, Iconnav, IconnavItem } from "vuikit";
import {
  Badge
  // ...
} from "element-ui";
Vue.use(Badge);
let items = [];
export default {
  name: "dashboard",
  searchdata: "",
  components: {
    // Widget,
    powerStat,
    OfflineDevices,
    AlarmDevices,
    OnLineDevices,
    AllDevices,
    // Modal,
    // VuesticSimpleSelect,
    Simplert,
    Battery,
    "vk-iconnav": Iconnav,
    "vk-icon": Icon,
    "vk-iconnav-item": IconnavItem
  },
  computed: {
    ...mapGetters([
      "DeviceList",
      "getUserByDevice",
      "getUserSession",
      "graphDeviceDetails",
      "offLineDeviceList",
      "onLineDevices",
      "uniqueFV",
      "uniqueSectors",
      "uniquePaymentModel",
      "filteredAllDevices",
      "getAssignedDevices",
      "filteredOnlineDevices",
      "filteredOffLineDevices",
      "filteredAlarmDevices",
      "getPerformanceFilter",
      "getGlobalTableOptions"
    ]),
    tableOptions: {
      get() {
        return this.getGlobalTableOptions.performance;
      },
    },
    getParams: {
      get(){
        return {
          page: this.tableOptions.currentPage,
          limit: this.tableOptions.currentPerPage,
          filter: this.filterMode,
          search: this.searchTerm
        }
      }
    },
    loadingState: {
      get() {
        return this.loadingState;
      }
    },
    criticalSystems: {
      //
      get() {
        let filteredIssues = this.filterIssues();
        if (filteredIssues) {
          this.setCriticalSystems(filteredIssues);
          // console.log("SHould Log");
          return filteredIssues;
        } else {
          return [];
        }
      }
      // set(newValue, oldValue){

      // }
    }
  },
  data() {
    return {
      totalDevicesShowing: "",
      paginatedInfo: {},
      showSearch: true,
      value: "live",
      searchTerm: "",
      details: "devicePerformance",
      myDevices: [],
      fetchData: [],
      retData: {},
      showCritical: false,
      loadingState: true,
      showOffOnlinelineDevices: null,
      showAllDevices: false,
      showOnlineOfline: true,
      showOnlineButton: true,
      showFilters: true,
      filterFirmWarVersion: "",
      filterSectorVal: "",
      filterPaymentModel: "",
      formDevice: {
        DeviceID: null,
        device_type: {
          name: "Arnergy 5000",
          description:
            "Bundled with : 3 LED bulbs, FM Radio and 1 x 20Wp High Efficiency Solar Panel.",
          status: 0,
          TimeStamp: new Date(),
          updatedAt: new Date()
        },
        location: {
          address: null,
          latitude: null,
          longitude: null
        },
        customer: {
          name: null,
          phone: null
        },
        subscription_type: {
          name: "Monthly Subscription",
          description: "User Pays Monthly",
          status: 0,
          TimeStamp: new Date(),
          updatedAt: new Date()
        },
        TimeStamp: new Date(),
        updatedAt: new Date(),
        outright_cost: 96796,
        initial_cost: 98533,
        installment_cost: 626882
      },
      deviceOptions: [
        "Arnergy 300",
        "Arnergy 1000",
        "Arnergy 2000",
        "Arnergy 5000"
      ],
      simpleSelectModel: "",
      timeRightNow: moment(),
      items: items,
      criticalColumns: [
        {
          key: "ownerName",
          label: "OWNED BY",
          sortable: true,
          field: "ownerName",
          filterable: true
        },
        {
          key: "deviceType",
          label: "DEVICE TYPE",
          sortable: "true",
          field: "InstallType",
          filterable: true
        },
        {
          key: "version",
          label: "VERSION",
          sortable: "true",
          field: "Version",
          filterable: true
        },
        {
          key: "InverterId",
          label: "DEVICE ID",
          sortable: "true",
          field: "DeviceID",
          filterable: true
        },
        {
          key: "Timestamp",
          label: "LAST SEEN",
          sortable: "true",
          field: "Timestamp",
          filterable: true
        }
      ],
      fields_: [
        {
          key: "status",
          label: "STATUS",
          field: "status"
        },
        {
          key: "ownerName",
          label: "OWNED BY",
          sortable: "true",
          field: "ownerName",
          type: "text",
          filterable: true
        },
        {
          key: "InverterId",
          label: "Device ID",
          sortable: "true",
          field: "InverterId",
          type: "text",
          filterable: true
        },
        // {
        //   key: "installedPV",
        //   label: "INSTALLED PV",
        //   sortable: false,
        //   field: "installedPV",
        //   filterable: true,
        //   hidden:
        //     this.$can("am", "customer") || this.$can("am", "sm") ? true : false,
        // },
        {
          key: "installedCapacity",
          label: "INSTALLED PV / CAPACITY",
          sortable: false,
          field: "installedCapacity",
          filterable: true,
          sortFn: this.numSort,
          firstSortType: "desc"
          // formatFn: this.formatCap,
        },
        // {
        //   key: "FV",
        //   label: "FIRMWARE VERSION",
        //   sortable: "true",
        //   field: "FV",
        //   filterable: true,
        // },
        {
          key: "version",
          label: "VERSION / FIRMWARE VERSION",
          sortable: "true",
          field: "version",
          filterable: true
        },
        // {
        //   key: "InverterId",
        //   label: "DEVICE ID",
        //   sortable: "true",
        //   field: "InverterId",
        //   filterable: true,
        //   // filterOptions: {
        //   //   enabled: true
        //   // }
        // },
        {
          key: "panelpower",
          label: "PV POWER",
          sortable: "true",
          field: "panelpower",
          filterable: true,
          type: "number",
          formatFn: this.formatFnPvP
        },
        {
          key: "batteryMode",
          label: "DEVICE STATUS",
          sortable: "true",
          field: "batteryMode",
          filterable: true
        },
        {
          key: "BatteryCapacity",
          label: "BATTERY",
          sortable: "true",
          field: "BatteryCapacity",
          filterable: true,
          sortFn: function(x, y, col, rowX, rowY) {
            // console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
            // x = Number(x);
            // y = Number(y);
            // console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
            // return x < y ? -1 : x > y ? 1 : 0;
          }
        },
        // {
        //   key: "expiry",
        //   label: "EXPIRY DATE",
        //   sortable: "true",
        //   field: "expiry",
        //   filterable: true
        // },
        // {
        //   key: "contractualLoad",
        //   field: "contractualLoad",
        //   label: "Contractual Load",
        //   sortable: true,
        //   filterable: true,
        //   hidden:
        //     this.$can("am", "customer") || this.$can("am", "sm") ? true : false,
        // },
        {
          key: "OutputLoadPercent",
          label: "CONTRACTUAL LOAD / LOAD %",
          sortable: "true",
          field: "OutputLoadPercent",
          filterable: true,
          sortFn: this.numSort
        },
        // {
        //   key: "lastseen",
        //   label: "LAST SEEN",
        //   sortable: false,
        //   field: "lastseen",
        //   filterable: true,
        //   type: "text",
        // },
        {
          key: "Time",
          field: "Time",
          label: "TIME",
          sortable: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy", // outputs Mar 16th 2018
          filterable: true,
          hidden:
            this.$can("am", "customer") || this.$can("am", "sm") ? true : false
        }
      ],
      currentPage: 1,
      // details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null
    };
  },
  methods: {
    ...mapActions([
      "performanceGraphCall",
      "handleFilters",
      "clearFilters",
      "setPerformanceFilter",
      "setGlobalTableOptions",
      "setCriticalSystems"
    ]),
    onClose() {},
    formatCap: function(value) {
      return value + "kVA";
    },
    formatFnPvP(v) {
      return v + "kW";
    },
    numSort(x, y, col, rowX, rowY) {
      console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
      x = Number(x);
      y = Number(y);
      console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
      return x < y ? -1 : x > y ? 1 : 0;
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
      this.filterFirmWarVersion = "";
      this.filterSectorVal = "";
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.clearFilters();
    },
    handleVersionFilterEnabler(fv) {
      this.filterFirmWarVersion = fv === "clear" ? "" : fv;
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.$store.commit("filterPaymentModel", this.filterPaymentModel);
      this.handleFilters();
    },
    handleSectorFilterEnabler(sector) {
      this.filterSectorVal = sector == "clear" ? "" : sector;
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterPaymentModel", this.filterPaymentModel);
      this.handleFilters();
    },
    handlePaymentModelFilterEnabler(paymentModel) {
      this.filterPaymentModel = paymentModel == "clear" ? "" : paymentModel;
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterPaymentModel", this.filterPaymentModel);
      this.handleFilters();
    },
    toggleShowOfflineOnlineDevices(status) {
      // console.log({ status });
      switch (status) {
        case "critical":
          this.toggleCritical();
          this.totalDevicesShowing = this.filterIssues().length;
          break;
        case "Offline":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 2;
          this.totalDevicesShowing = this.filteredOffLineDevices.length;
          this.setPerformanceFilter(2);
          break;
        case "Alarm":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 4;
          this.totalDevicesShowing = this.filteredAlarmDevices.length;
          this.setPerformanceFilter(4);
          break;
        case "Online":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 1;
          this.totalDevicesShowing = this.filteredOnlineDevices.length;
          this.setPerformanceFilter(1);
          break;
        case "All":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 3;
          this.totalDevicesShowing = this.filteredAllDevices.length;
          console.log(this.paginatedInfo);
          this.setPerformanceFilter(3);
          break;
        default:
          this.showCritical = false;
          this.showOffOnlinelineDevices = 1;
          this.totalDevicesShowing = this.filteredOnlineDevices.length;
          this.setPerformanceFilter(1);
          break;
      }

      let tmpState = {
        ...this.getGlobalTableOptions,
        performance: {
          ...this.getGlobalTableOptions.performance,
          currentPage: 1
        }
      };
      this.setGlobalTableOptions(tmpState);
      // if (this.activeTab === true) {
      //   console.log("Online"+this.activeTab );

      // }
      //toggleCritical()
      // this.showOffOnlinelineDevices = !status;
      // if (this.showOfflineDevices) {
      //   this.showCritical = false;
      // }
      // this.showCritical=
    },
    filterIssues() {
      if (this.DeviceList.length > 0) {
        return this.DeviceList.filter(x => {
          if (typeof x === "object") {
            // console.log({ x: typeof x });
            if (x.payload) {
              const dayDiff = moment().diff(
                moment(x.payload.TimeStamp || x.payload.Timestamp),
                "days"
              );
              return x.payload.InverterDetected == "NO" && dayDiff < 4;
              // console.log({ x: typeof x.payload });
            } else {
              // console.log({ noPayload: x });
            }
          } else {
            // console.log({ xNotObject: x });
          }
        }).reduce((acc, cur) => {
          // console.log(cur);
          let _tmp = {
            ...cur.payload,
            ownerName: cur["owner"][0] ? cur["owner"][0]["name"] : "Unassigned"
          };
          return [...acc, _tmp];
        }, []);
      }
    },
    toggleCritical() {
      this.showCritical = !this.showCritical;
      // console.log({ Oop: this.DeviceList });
    },
    searchToggle() {
      this.showSearch = !this.showSearch;
    },
    toggleShowAllDevices(showAllDevices) {
      console.log({ showAllDevices });
    },
    changeToggle() {
      //console.log("i am here",this.value);
      if (this.value == "all") {
        this.$router.push({
          path: "/performance/all"
        });
      } else {
        this.$router.push({
          path: "/performance/live"
        });
      }
    },
    tableRowClicked(params) {
      if(params.row.batteryMode !== "inv not detected"){
        this.navTo(params.row);
      }
    },
    getFetchData(CID) {
      try {
        return (
          this.fetchData.find(x => x.CID == CID || x.solarKitIds == CID) || {
            name: "Arnergy Solar",
            userId: "5"
          }
        );
      } catch (error) {
        return { name: "Arnergy Solar", userId: "5" };
      }
      //.then(res=> {return res[0].name}).catch((err)=> {return''})
      // return null || this.fetchData.filter(x => x.solarKitIds == inverterId)[0].name
    },
    filterIt(arr, searchKey) {
      if (searchKey.length < 3) return arr;
      else
        return arr.filter(obj =>
          Object.keys(obj).some(key => obj[key].includes(searchKey))
        );
    },
    handleFilter(data) {
      let type = this.$route.params["live"] == "live" ? true : false;
      return data.filter(x => {
        // console.log(this.statusCalc(x.TimeStamp));

        // console.log(x && type ? this.statusCalc(x.TimeStamp) == false : true);
        return x && type ? this.statusCalc(x.TimeStamp) == false : true;
      });
    },
    transformDevice(data) {
      // console.log(this.$route.params);
      // payloadDictionary
      // data = [...data, dummyData];
      // graphDeviceDetails
      let d = this.graphDeviceDetails();
      console.log(d);
      console.log(">>data<<");

      let type = this.$route.params["live"] == "live" ? true : false;
      return data
        .filter(x => {
          //  return (
          //   typeof x.payload === "object" &&
          //   x.payload !== "null" &&
          //   x.payload.InverterDetected == "NO"
          // );

          if (
            typeof x.payload === "object" &&
            typeof x.payload !== "null" &&
            typeof x.payload !== "undefined" &&
            x.payload.InverterDetected == "NO"
          ) {
            let inverterFlag =
              x.payload &&
              x.payload.InverterDetected &&
              x.payload.InverterDetected == "NO"
                ? true
                : false;
            return x.payload && !inverterFlag;
          }
        })
        .map((val, i) => {
          if (val.payload.Version == "v4") {
            let tempData = this.getFetchData(val.DeviceID);
            var resp = "--";
            switch (val.payload.ModeData[0]["Mode"]) {
              case "P":
              case "00":
                resp = "Power On";
                break;
              case "S":
              case "01":
                resp = "On Standby";
                break;
              case "L":
              case "E":
              case "05":
                resp = "On Grid";
                break;
              case "Y":
              case "02":
                resp = "Bypass Mode";
                break;
              case "B":
              case "03":
                resp = "On Battery";
                break;
              case "F":
              case "04":
                resp = "Fault";
                break;
              case "H":
                resp = "Power saving mode";
                break;
              case "C":
              case "06":
                resp = "Charging";
                break;
              default:
                resp = val.payload.ModeData[0]["Mode"];
              // code block
            }
            // console.log('=====================V4===========')
            // console.log(val.payload);
            return {
              version: val.payload.Version,
              InverterId: val.payload.BatteryData.BatteryID,
              TimeStamp: val.payload.Timestamp,
              OutputLoadPercent: this.roundUp(
                val.payload.PowerData.reduce((acc, obj) => {
                  return (acc += Number(obj["OL%"]));
                }, 0) / val.payload.PowerData.length
              ),
              id: val.payload.DeviceID,
              panelpower: this.panelPowerReduce(val.payload.PowerData, "v4"),
              BatteryCapacity: val.payload.BatteryData.SOC.replace("%", ""),
              deviceType: tempData.deviceType
                ? tempData.deviceType.name
                : "Arnergy Custom",
              ownerName: tempData.name,
              ownerId: tempData.userId,
              address: tempData["locations"],
              batteryMode: resp,
              expiry: val.payload.ExpiryDate,
              lastseen: this.timeAgo(val.payload.Timestamp, tempData.name)
            };
          } else if (val.payload.Version == "v3") {
            // {
            let tempData = this.getFetchData(val.DeviceID);
            var resp = "--";
            switch (val.payload.ModeData[0]["Mode"]) {
              case "P":
                resp = "Power On";
                break;
              case "S":
                resp = "On Standby";
                break;
              case "L":
                resp = "On Grid";
                break;
              case "E":
                resp = "On Grid";
                break;
              case "Y":
                resp = "Bypass Mode";
                break;
              case "B":
                resp = "On Battery";
                break;
              case "F":
                resp = "Fault";
                break;
              case "H":
                resp = "Power saving mode";
                break;
              case "C":
                resp = "Charging";
                break;
              default:
                resp = val.payload.ModeData[0]["Mode"];
              // code block
            }
            return {
              version: val.payload.Version,
              InverterId: val.payload.BatteryData.BatteryID,
              TimeStamp: val.payload.Timestamp,
              OutputLoadPercent: this.roundUp(
                val.payload.InverterData.reduce((acc, obj) => {
                  return (acc += Number(obj["OL%"]));
                }, 0) / val.payload.InverterData.length
              ),
              id: val.payload.DeviceID,
              panelpower: this.panelPowerReduce(val.payload.InverterData),
              BatteryCapacity: val.payload.BatteryData.SOC.replace("%", ""),
              deviceType: tempData.deviceType
                ? tempData.deviceType.name
                : "Arnergy Custom",
              ownerName: tempData.name,
              ownerId: tempData.userId,
              address: tempData["locations"],
              batteryMode: resp,
              expiry: val.payload.ExpiryDate,
              lastseen: this.timeAgo(val.payload.Timestamp, tempData.name)
            };
            // }
          }
          //  else if (val.payload.InstallType == "v4") {
          //   let tempData = this.getFetchData(val.DeviceID);
          //   var resp = "--";
          //   switch (val.payload.ModeData[0]["Mode"]) {
          //     case "P":
          //       resp = "Power On";
          //       break;
          //     case "S":
          //       resp = "On Standby";
          //       break;
          //     case "L":
          //       resp = "On Grid";
          //       break;
          //     case "E":
          //       resp = "On Grid";
          //       break;
          //     case "Y":
          //       resp = "Bypass Mode";
          //       break;
          //     case "B":
          //       resp = "On Battery";
          //       break;
          //     case "F":
          //       resp = "Fault";
          //       break;
          //     case "H":
          //       resp = "Power saving mode";
          //       break;
          //     case "C":
          //       resp = "Charging";
          //       break;
          //     default:
          //       resp = val.payload.ModeData[0]["Mode"];
          //     // code block
          //   }
          //   console.log(val.payload.PowerData)
          //   return {
          //     version: val.payload.Version,
          //     InverterId: val.payload.BatteryData.BatteryID,
          //     TimeStamp: val.payload.Timestamp,
          //     OutputLoadPercent: this.roundUp(
          //       val.payload.InverterData.reduce((acc, obj) => {
          //         return (acc += Number(obj["OL%"]));
          //       }, 0) / val.payload.InverterData.length
          //     ),
          //     id: val.payload.DeviceID,
          //     panelpower: this.panelPowerReduce(val.payload.PowerData),
          //     BatteryCapacity: val.payload.BatteryData.SOC.replace("%", ""),
          //     deviceType: tempData.deviceType
          //       ? tempData.deviceType.name
          //       : "Arnergy Custom",
          //     ownerName: tempData.name,
          //     ownerId: tempData.userId,
          //     address: tempData["locations"],
          //     batteryMode: resp,
          //     expiry: val.payload.ExpiryDate,
          //     lastseen: this.timeAgo(val.payload.Timestamp, tempData.name)
          //   };
          // }
          else {
            let tempData = this.getFetchData(val.DeviceID);
            console.log(val);
            console.log(">>>>>>>>>>valvalval<<<<<<<<<<<<<<<<<<<");
            console.log(tempData);
            console.log(">>>>>>>>>>tempData<<<<<<<<<<<<<<<<<<<");

            return {
              version: "v2",
              InverterId: val.DeviceID,
              TimeStamp: val.payload.TimeStamp,
              OutputLoadPercent: val.payload.OutputLoadPercent,
              id: tempData.CID,
              panelpower: this.panelPower(val.payload.PVChargingPower),
              BatteryCapacity: val.payload.BatteryCapacity,
              deviceType: tempData.deviceType
                ? tempData.deviceType.name
                : "Arnergy5000",
              ownerName: tempData.name,
              ownerId: tempData.userId,
              address: tempData["locations"],
              batteryMode: this.batteryMode(val.payload.InverterId),
              expiry: this.expiryDate(val.payload.InverterId),
              lastseen: this.timeAgo(val.payload.TimeStamp)
            };
          }
          // }
        })
        .filter(x => {
          // console.log(x && type ? this.statusCalc(x.TimeStamp) == false : true);
          return x && type ? this.statusCalc(x.TimeStamp) == false : true;
        });
    },
    roundUp(num) {
      return num.toFixed(2);
    },
    async getDevice(inverterId) {
      const context = this;
      const HTTP = this.$httpUtils.instance;
      //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
      const url = `/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations`;
      return await HTTP.get(url)
        .then(response => {
          context.fetchData = response.data;
          // console.log(context.fetchData);
        })
        .catch(error => {
          return "not assign";
          //console.log("error", error);
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    panelPowerReduce(InverterData, version = "v3") {
      var power = InverterData.reduce((acc, parameter) => {
        let powerKey = `PVCgP${version == "v4" ? "1" : ""}`;
        // console.log("i am parameter", Object.keys(parameter));
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0);
      return power / 1000 + "kW";
    },
    submitAddForm() {
      // console.log(JSON.stringify(this.formDevice));
      var dataParam = this.formDevice;
      if (
        dataParam.DeviceID === null ||
        dataParam.device_type.name === null ||
        dataParam.location.address === null ||
        dataParam.customer.name === null ||
        dataParam.customer.phone === null ||
        dataParam.DeviceID === "" ||
        dataParam.device_type.name === "" ||
        dataParam.location.address === "" ||
        dataParam.customer.name === "" ||
        dataParam.customer.phone === ""
      ) {
        let obj = {
          title: "Please fill all fields!!!",
          message: "",
          type: "error",
          onClose: this.onClose
        };
        this.$refs.simplert.openSimplert(obj);
        // alert('Please fill all fields!!!')
      } else {
        const me = this;
        const HTTP = this.$httpUtils.instance;
        HTTP.post("/devices", me.formDevice)
          .then(function(response) {
            me.fetchDevices();
            let obj = {
              title: "Device Created!!!",
              message: "",
              type: "info",
              onClose: me.onClose
            };
            me.$refs.simplert.openSimplert(obj);
          })
          .catch(function(error) {
            // console.log(error);
            let obj = {
              title: "Error, Try again!!!",
              message: "",
              type: "error",
              onClose: me.onClose
            };
            me.$refs.simplert.openSimplert(obj);
          });
        me.hideControl();
      }
    },
    showFormPop() {
      this.$refs.formModal.open();
    },
    hideControl() {
      this.$refs.formModal.cancel();
    },
    formatDate(_date) {
      return moment(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    navTo(device) {
      let { id, version, InverterId } = device;
      // let { DeviceID } = device;
      // console.log( {device});
      this.$router.push({
        name: "devicePerformance",
        params: {
          deviceId: id ? id : InverterId,
          version: version ? version : "v2"
        }
      });
      // console.log(this.details,device)
    },
    roundUp(num) {
      return Math.round(num * 100) / 100;
    },
    Parse_Json(data) {
      return JSON.parse(data);
    },
    countErrors(Warning) {
      var excluded = [
        "id",
        "deviceID",
        "TimeStamp",
        "TimeStamp",
        "updatedAt",
        "lineFail"
      ];
      var totalErr = 0;
      for (var property in Warning) {
        if (
          Warning.hasOwnProperty(property) &&
          excluded.indexOf(property) < 0
        ) {
          // do stuff
          if (Warning[property] > 0) {
            totalErr++;
            // console.log(property);
          }
        }
      }
      return totalErr;
    },
    errorCalc(Warning) {
      var excluded = [
        "id",
        "deviceID",
        "TimeStamp",
        "TimeStamp",
        "updatedAt",
        "lineFail"
      ];
      var totalErr = 0;
      for (var property in Warning) {
        if (
          Warning.hasOwnProperty(property) &&
          excluded.indexOf(property) < 0
        ) {
          // do stuff
          if (Warning[property] > 0) {
            totalErr++;
            // console.log(property);
          }
        }
      }
      // var msg_ = ' Error'
      if (totalErr > 0) {
        return true;
      }
      return false;
    },
    findDeviceData(dataset, key, value) {
      const res = dataset.filter(x => x[key] == value);
      return res.length > 0 ? res : undefined;
    },
    batteryMode(deviceID) {
      // console.log(this.DeviceList.modes);
      // this.DeviceList.modes
      const deviceMode = this.findDeviceData(
        this.DeviceList.modes,
        "DeviceID",
        deviceID
      );
      // console.log(deviceID);
      // console.log(deviceMode);

      var mode =
        deviceMode !== undefined ? deviceMode[0]["payload"]["Mode"] : "";
      var resp = "--";
      switch (mode) {
        case "P":
          resp = "Power On";
          break;
        case "S":
          resp = "On Standby";
          break;
        case "L":
          resp = "On Grid";
          break;
        case "B":
          resp = "On Battery";
          break;
        case "F":
          resp = "Fault";
          break;
        case "H":
          resp = "Power saving mode";
          break;
        case "C":
          resp = "Charging";
          break;
        default:
        // code block
      }
      return resp;
    },
    expiryDate(deviceID) {
      const deviceExpiry = this.findDeviceData(
        this.DeviceList.expiries,
        "DeviceID",
        deviceID
      );

      return deviceExpiry !== undefined
        ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"])
        : "--";
    },
    timeAgo(date, name) {
      // console.log(name);
      // console.log(this.timeRightNow);
      // console.log(date);

      // var difference = date.add(1, "hours").fromNow();
      // var difference = Math.abs(this.timeRightNow.diff(date));
      // console.log(moment(date).from(this.timeRightNow));
      // console.log("==============================================");
      return moment(date).from(this.timeRightNow);
      // return timeAgoUtil(difference);
      // console.log(moment(date, "Africa/Lagos").fromNow());
      // if (difference / 60000 > 90) {
      //   return true;
      // } else {
      //   return false;
      // }

      // return moment(date)
      //   .add(1, "hours")
      //   .format()
      //   .toString();
    },
    statusCalc(date) {
      // console.log( moment(date).diff(this.timeRightNow));
      var difference = Math.abs(moment(date).diff(this.timeRightNow));
      if (difference / 60000 > 90) {
        return true;
      } else {
        return false;
      }
    },
    statusLabel(date) {
      var difference = Math.abs(moment().diff(date));
      if (difference / 60000 > 90) {
        return "Offline";
      } else {
        return "Online";
      }
    },
    panelPower(PVChargingPower) {
      // console.log(parameters);
      var power = this.roundUp((PVChargingPower * 1) / 1000);
      return power + " kW";
    },
    powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    async fetchDevices() {},
    async getCurrentCustomerDeviceIds() {
      const httpUtils = this.$httpUtils;
      let userId = this.getUserSession.id;
      let url = `/installations?filter={"where":{"and": [{"userId":${userId}}, {"or":[{ "status": "requested"},{ "status": "commissioned"},{ "status": "completed"}]}]}}`;
      const result = await httpUtils.instance.get(url);
      const res = result.data.map(item => item.CID);
      this.$store.commit("setAssignedDevices", res);
      return res;
    },
    async currentTime() {
      const me = this;
      const HTTP = this.$httpUtils.instance;
      let response = await HTTP.get(
        "https://arnergy.com/weather-api/time/?" + Date.now()
      );
      if (response) {
        if (response.data.datetime) {
          let tmpDate = response.data.datetime.split(".")[0];
          return tmpDate;
        }
      }
    },
    get() {
      this.$socket.emit(
        "get",
        JSON.stringify({ action: "sendMessage" }),
        response => {
          console.log(response);
        }
      );
    },
    add() {
      // Emit the server side
      this.$socket.emit("add", JSON.stringify({ action: "sendMessage" }));
    },
    sleep(ms) {
      // console.log(ms + "here");

      return new Promise(resolve => setTimeout(resolve, ms));
    }
    // checkOnboardedCustomer(id) {
    //   const HTTP = this.$httpUtils.instance;

    //   HTTP.get(
    //     `/onboardingStates/findOne?filter={"where":{"customerid":${id}}}`
    //   )
    //     .then((response) => {
    //       if (response.data.stateid < 7) window.location.href = "/onboarding";
    //       if (response.data.stateid == 7)
    //         window.location.href = "/onboarding/finish-tab";
    //     })
    //     .catch((error) => {
    //       console.log({ error });
    //     });
    // },
  },
  created() {},
  async mounted() {
    // this.checkOnboardedCustomer(this.getUserSession.id)
    this.toggleFilters();
    this.totalDevicesShowing = this.filteredAllDevices.length;
    // https://worldtimeapi.org/api/timezone/Africa/Lagos
    // await this.
    this.loadingState = true;
    if (this.$can("see", "installation")) {
      this.showOffOnlinelineDevices = this.getPerformanceFilter;
    }
    this.timeRightNow = await this.currentTime();
    let { timeRightNow } = this;
    // console.log({timeRightNow});
    if (this.$can("am", "customer")) {
      // I am a customer...
      // console.log({whoami:"Customer"});
      const deviceIds =
        this.getAssignedDevices != null
          ? this.getAssignedDevices
          : await this.getCurrentCustomerDeviceIds(); // ==> ['416931', '416850'];
      // alert(deviceIds);
      if (deviceIds.length < 1) {
        this.showOffOnlinelineDevices = null;
        return;
      }
      await this.performanceGraphCall({
        timeRN: this.timeRightNow,
        arrayOfIds: deviceIds
      });
    } else if (this.$can("am", "sm")) {
      // I am a section manager...
      let assignedDevices = [];
      try {
        assignedDevices = JSON.parse(this.getUserSession.assignedDevices);
      } catch (error) {
        assignedDevices = this.getUserSession.assignedDevices.split(",");
      }
      await this.performanceGraphCall({
        timeRN: this.timeRightNow,
        arrayOfIds: assignedDevices
      });
      // console.log({ assignedDevices });
    } else if (this.$can("manage", "allDevices")) {
      // alert("all");
      await this.performanceGraphCall({
        timeRN: this.timeRightNow
      });
    }
    let filtrdIssues = this.filterIssues();
    this.setCriticalSystems(filtrdIssues);
    this.loadingState = false;
  }
};
</script>

<style lang="scss">
.loadingState {
  display: flex;
  height: 300px;
  align-items: center;
  justify-content: center;
}
h1,
h2,
p {
  margin: 0;
}
.page-content__header-description,
.container-fluid {
  margin: 0;
  padding-top: 0px;
  padding-bottom: 0px;
}
.page-title {
  margin: 0;
  margin-bottom: 8px;
}
.label-container {
  display: flex;
}
.label-container > div {
  margin-right: 10px;
}
.label-container > div:last-child {
  margin-right: 0px;
}
.default-label {
  background-color: #ffffff;
  border: 1px solid #eff0f4;
  border-radius: 15px;
  display: flex;
  padding: 5px 10px;
  cursor: pointer;
}
.default-label p {
  font-size: 12px;
  padding-bottom: 0px !important;
  margin-bottom: 0px !important;
}
.default-label .green-label {
  color: rgba(100, 206, 17, 0.5);
}
.active-green-filter {
  background-color: rgb(100, 206, 17);
}
.default-label .orange-label {
  color: rgba(254, 122, 17, 0.5);
}
.active-orange-filter {
  background-color: rgb(254, 122, 17);
}
.default-label .yellow-label {
  color: rgba(219, 179, 0, 0.5);
}
.active-yellow-filter {
  background-color: rgb(219, 179, 0);
}
.default-label .red-label {
  color: rgba(255, 0, 0, 0.5);
}
.active-red-filter {
  background-color: rgb(255, 0, 0);
}
.default-label .blue-label {
  color: rgba(26, 147, 201, 0.5);
}
.active-blue-filter {
  background-color: rgb(26, 147, 201);
}
.active-blue-filter p.blue-label,
.active-red-filter p.red-label,
.active-yellow-filter p.yellow-label,
.active-green-filter p.green-label,
.active-orange-filter p.orange-label {
  color: rgba(255, 255, 255, 0.75);
}
.default-label .device-amount {
  color: #1e2833;
  margin-left: 10px;
}
.active-blue-filter .device-amount,
.active-red-filter .device-amount,
.active-yellow-filter .device-amount,
.active-green-filter .device-amount,
.active-orange-filter .device-amount {
  color: rgb(255, 255, 255);
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.display-search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.el-input--prefix .el-input__inner {
  border-radius: 10px;
  width: 360px;
  background-color: #eff0f4;
  border-color: #eff0f4;
}
.hide_row {
  display: hidden !important;
}
.loadingState {
  animation-direction: alternate;
}
.activeFilter {
  font-size: 93% !important;
}
.critical_pin * {
  color: red !important;
}
.main-container {
  height: calc(100vh - 330px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/performance/index.vue